module.exports = __webpack_public_path__ + "images/Minus_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Minus_hover.png
// module id = 388
// module chunks = 0 1